<template>
  <tr
    v-bind="$attrs"
    class="table_row"
    :class="{
      'table_row--active': active,
      'table_row--bordered': bordered && !isLast,
      'table_row--light-error': errorLight,
      'table_row--dark-error': errorDark,
    }"
    v-tippy
    :title="tooltip"
    @show="() => !!tooltip"
  >
    <slot></slot>
  </tr>
</template>

<script>
export default {
  name: "TableRow",
  props: {
    /**
     * @vuese
     * Flag when true it colors the background to indicate an active state.
     */
    active: {
      type: Boolean,
      default: false,
    },
    // Applies border bottom to the row
    bordered: {
      type: Boolean,
      default: false,
    },
    // Flag to indicate that the appropriate styling should be applied
    isLast: {
      type: Boolean,
      default: false,
    },
    errorLight: {
      type: Boolean,
      default: false,
    },
    errorDark: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../style_variables/style_variables.scss";
@import "~include-media";
$hover_blue: #e9f0fe;
$light_red_error: #f8ecec;
$dark_red_error: #f3d9d9;

tr {
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  vertical-align: baseline;

  &:hover > td {
    background: $hover_blue;
  }

  &.table_row {
    &.table_row--active > td {
      background: $hover_blue;
    }
    &.table_row--bordered {
      border-bottom: 1px solid $grey_bg;
      @include media("<tablet") {
        border-bottom: none;
      }
    }
    &.table_row--light-error > td {
      background-color: $light_red_error;
    }
    &.table_row--dark-error > td {
      background-color: $dark_red_error;
    }
  }
}
</style>
